import { useState, useEffect } from 'react';

import templatelyLogo from './assets/templately.svg';
import { useDispatch, useSelector } from 'react-redux';
import { iWantTemplatelyFree } from '../../../actions/CheckoutActions';

const templatelyPrices = {
	1: '6.99/mo',
	3: '9.99/mo',
	6: '19.99/mo',
};

export function Templately({ month = 1, appSumo = false }) {
	const dispatch = useDispatch();
	const templatelyFree = useSelector(state => {
		return state.checkout.templatelyFree ?? 'FreeCard';
	});
	const [selected, setSelected] = useState(templatelyFree);

	useEffect(() => {
		if (templatelyFree !== selected) {
			dispatch(iWantTemplatelyFree(selected));
		}
	}, [selected, templatelyFree]);

	return (
		<>
			<form>
				<input
					type="radio"
					id="FreeCard"
					name="productCard"
					value="FreeCard"
					// defaultChecked={true}
					style={{ display: 'none' }}
					checked={selected === 'FreeCard'}
					onChange={() => setSelected('FreeCard')}
				/>

				{!appSumo && (
					<input
						type="radio"
						id="noThanksCard"
						name="productCard"
						value="FreeCard"
						// defaultChecked={false}
						style={{ display: 'none' }}
						checked={selected === 'noThanksCard'}
						onChange={() => setSelected('noThanksCard')}
					/>
				)}

				<div className="wp-checkout-flex gap-8 wp-checkout-templately-free-card-wrapper ">
					<label
						htmlFor="FreeCard"
						className={`wp-checkout-flex wp-checkout-flex-space-between wp-checkout-templately-free-card ${selected === 'FreeCard' ? 'select-item' : ''} ${appSumo ? 'ea-included-for-appsumo' : ''}`}
					>
						<div className="full-width wp-checkout-flex">
							<div className="wp-checkout-card-right-content">
								<div className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-flex-center">
									<div className="wp-checkout-flex wp-checkout-flex-space-betwee">
										<div className="wp-checkout-card-left-content">
											<img src={templatelyLogo} />
										</div>
										<h3 className="wp-checkout-font-base wp-checkout-product-card-title">
											Templately Pro
											<span className="wp-checkout-font-sm wp-checkout-free-tag">
												{!appSumo
													? 'Best Deal'
													: 'Included Free'}
											</span>
										</h3>
									</div>

									<div className="free-card-icon-wrapper"></div>
								</div>

								{!appSumo && (
									<p className="wp-checkout-font-sm wp-checkout-free-card-sub-header">
										{month} {month > 1 ? 'Months' : 'Month'}{' '}
										<span className="wp-checkout-semi-bold-text">
											FREE
										</span>{' '}
										Subscription
									</p>
								)}

								{appSumo && (
									<p className="wp-checkout-font-sm wp-checkout-free-card-sub-header">
										6500+ ready templates free for {month}{' '}
										{month > 1 ? 'months' : 'month'}{' '}
									</p>
								)}
								<div className="wp-checkout-flex wp-checkout-flex-center">
									<h3 className="wp-checkout-font-xl wp-checkout-current-price">
										$0.00
									</h3>
									<h4 className="wp-checkout-font-sm wp-checkout-old-price">
										{' '}
										{templatelyPrices[+month]}
									</h4>
								</div>
							</div>
						</div>
					</label>

					{!appSumo && (
						<label
							htmlFor="noThanksCard"
							className={`wp-checkout-templately-free-card wp-checkout-no-thanks-card  ${selected === 'noThanksCard' ? 'select-item' : ''}`}
						>
							<div className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-flex-center wp-checkout-no-thanks-header">
								<h3 className="wp-checkout-font-base wp-checkout-product-card-title">
									Maybe Later
								</h3>
								<div className="free-card-icon-wrapper"></div>
							</div>
							<div className="wp-checkout-product-card-sub-title-wrapper">
								<p className="wp-checkout-font-sm wp-checkout-product-card-sub-title">
									I want to{' '}
									<strong className="wp-checkout-semi-bold-text">
										MISS
									</strong>{' '}
									access to{' '}
									<strong className="wp-checkout-semi-bold-text">
										3,000+ ready templates
									</strong>{' '}
									with AI credits for FREE
								</p>
							</div>
						</label>
					)}
				</div>
			</form>
		</>
	);
}
